<template>
  <div>
    <v-dialog v-model="hideShow" width="1120" persistent scrollable content-class="course-balance-warning-dialog" aria-label="课时余额不足提醒">
      <v-card class="wa-shell bw-shell">
        <v-card-title class="wa-header">
          <span class="wa-symbol"><v-icon size="26" color="#d9363e">mdi-wallet-outline</v-icon></span>
          <div class="wa-heading"><h2>课时余额不足提醒</h2><p>关注学员课时余额，及时跟进续费安排</p></div>
          <span class="wa-count"><strong>{{data.total}}</strong><span>条预警</span></span>
          <v-btn icon aria-label="关闭课时余额不足提醒" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="wa-body">
          <div class="bw-notice"><v-icon size="18" color="#b78139">mdi-information-outline</v-icon><span>请关注剩余课时，及时与家长沟通续费。</span><span class="bw-legend"><i class="bw-legend-dot" />负数余额重点关注</span></div>
          <v-data-table class="wa-table bw-table" :headers="data.headers" :items="data.list" :loading="query.loading" fixed-header disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" no-data-text="暂无课时余额预警" :mobile-breakpoint="0">
            <template v-slot:item.courseName="{item}"><span class="bw-course">{{item.courseName}}</span></template>
            <template v-slot:item.studentNo="{item}"><span class="bw-student-no">{{item.studentNo}}</span></template>
            <template v-slot:item.studentName="{item}"><span class="bw-student">{{item.studentName}}</span></template>
            <template v-slot:item.contactorMobile="{item}"><span class="bw-contact">{{item.contactorMobile || '—'}}</span></template>
            <template v-slot:item.totalClassHour="{item}"><span class="bw-number">{{item.totalClassHour}}</span></template>
            <template v-slot:item.usedClassHour="{item}"><span class="bw-number bw-used">{{item.usedClassHour}}</span></template>
            <template v-slot:item.balanceHour="{item}"><span class="bw-balance" :class="{'bw-balance-negative':Number(item.balanceHour)<0,'bw-balance-zero':Number(item.balanceHour)===0}" :aria-label="'剩余课时 '+item.balanceHour">{{item.balanceHour}}</span></template>
            <template v-slot:no-data><div class="wa-empty"><v-icon size="40" color="#a8b7c7">mdi-wallet-outline</v-icon><strong>暂无课时余额预警</strong><span>当前范围内没有需要提醒的课时账户</span></div></template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="wa-footer">
          <div class="wa-page-size"><span>每页</span><v-select :items="[10,20,50,100]" @change="handleSizeChanged" dense hide-details outlined v-model="query.size" color="#d9363e" aria-label="每页记录数量" /><span>条</span></div>
          <span class="wa-total">共 {{data.total}} 条</span>
          <v-spacer />
          <v-pagination v-if="Math.ceil(data.total/query.size)>0" class="wa-pagination" :length="Math.ceil(data.total/query.size)" @input="handlePageChanged" :total-visible="5" v-model="query.page" color="#d9363e" aria-label="课时预警分页" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"course-account-warn",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
				this.hideShow = newVal;
				if(this.hideShow){
					this.getDataList();
				}
			}
		},
		data(){
			return {
				query:{
					page:1,
					size:10
				},
				hideShow:this.show,
				shopId:"",
				data: {
					total:0,
					headers:[
						{
							text: '课程名称',
							value: 'courseName',
							sortable: false
						},
						{
							text: '学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '联系手机',
							value: 'contactorMobile',
							sortable: false
						},
						{
							text: '总课时',
							value: 'totalClassHour',
							sortable: false
						},
						{
							text: '已用课时',
							value: 'usedClassHour',
							sortable: false
						},
						{
							text: '剩余课时',
							value: 'balanceHour',
							sortable: false
						},
					],
					list:[],
					
				},
				
			}
		},
		mounted() {
			console.log("course-account-warn mounted");
			this.shopId = utils.getCurrentShopId();
			this.getDataList();
		
		},
		methods:{
			handleSizeChanged(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getDataList();
			},
			handlePageChanged(page) {
				this.query.page = page;
				this.getDataList();
			},
			getDataList(){
				const that = this;
				const classId = this.classId;
				let url = `/report/course/account/warning/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if(this.shopId){
					url += "&shopId="+this.shopId;
				}
					
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						console.log(response.data);
						
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				})
			},
			cancel(){
				this.$emit("cancel","")
			},

		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/course-balance-warning.scss"></style>
